import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {

	return {
		infoRoot: {
			position           : "absolute",
			bottom             : "0",
			overflow           : "scroll",
			overscrollBehavior : "none",
			left               : "0",
			right              : "0",
			userSelect         : "none",
			maxHeight          : "60vh",
			zIndex             : 5,
			display            : "flex",
			flexDirection      : "column",
			gap                : "0.4rem",
			transition         : "height 0.5s ease-in-out",
			padding            : "1.5rem",

			[rooterMediaQuery.mobile]: {
				padding : "0 1rem 1rem 1rem",
				width   : "84%"
			}
		},
		actorImage: {
			cursor       : "pointer",
			width        : "4rem",
			height       : "4rem",
			borderRadius : "50%"
		},
		seeMoreBtn: {
			padding    : "0",
			background : "none",
			position   : "relative",
			color      : theme.other.paletteNew.secondaryWhite,
			opacity    : "0.5",
			cursor     : "pointer",
			whiteSpace : "nowrap",
			border     : "none"
		},
		descWrapper: {
			display    : "flex",
			cursor     : "pointer",
			alignItems : "end"
		},
		test: {
			height       : "40%",
			width        : "100%",
			borderRadius : "0 0 1rem 1rem",
			zIndex       : 2,
			background   : "linear-gradient(to top,black, transparent)",
			opacity      : "0.5",
			position     : "absolute",
			bottom       : "0",
			left         : "0",

			[rooterMediaQuery.mobile]: {
				borderRadius: "0"
			}
		},
		reelTitle: {
			display                   : "-webkit-box",
			WebkitBoxOrient           : "vertical",
			color                     : theme.other.paletteNew.secondaryWhite,
			width                     : "90%",
			overflow                  : "hidden",
			// textOverflow     : "ellipsis",
			WebkitLineClamp           : 1,
			wordBreak                 : "break-word",
			[rooterMediaQuery.mobile] : {
				fontSize: "1.4rem"
			},
			"&[data-opened]": {
				WebkitLineClamp : "unset",
				cursor          : "pointer"
			},
			transition: "all 0.5s ease-in-out"
		},
		followComponent: {
			background   : "none",
			border       : "1px solid white",
			borderRadius : "0.8rem",
			padding      : "0.4rem 1rem",
			cursor       : "pointer",
			"&:hover"    : {
				background: "none"
			}
		},
		iconText: {
			color: "white"
		},
		reelViews: {
			opacity  : "0.5",
			fontSize : "1.4rem !important",
			color    : theme.other.paletteNew.secondaryWhite
		},
		actorName: {
			cursor     : "pointer",
			fontWeight : "500",
			color      : theme.other.paletteNew.secondaryWhite
		}
	};
} );